export function getPublicNavButtonSx(isActive = false) {
  return {
    color: 'white',
    borderRadius: 0,
    fontSize: 18,
    minWidth: 0,
    px: 1.5,
    py: 0.75,
    width: '100%',
    borderBottom: isActive ? '3px solid #fff' : '3px solid transparent',
  }
}

/** Brand control uses MUI Button so CssBaseline `a:not(.MuiButtonBase-root)` does not force #3b3e66. */
export function getPublicBrandLinkSx() {
  return {
    color: '#fff',
    textTransform: 'none',
    justifyContent: 'flex-start',
    minWidth: 0,
    maxWidth: '100%',
    px: 1,
    py: 0.5,
    fontWeight: 700,
    fontSize: { xs: 14, sm: 18 },
    lineHeight: 1.2,
    '&:hover': {
      color: '#fff',
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  }
}

/** Dark wordmarks (e.g. Next Level) sit on a white chip against the navy bar. */
export function getPublicBrandLogoWrapSx() {
  return {
    backgroundColor: '#fff',
    borderRadius: '0.29rem',
    height: 40,
    px: 0.75,
    mr: 1,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    boxShadow: '1px 1px 3px rgba(7, 9, 25, 0.2)',
    '& img': {
      height: 28,
      width: 'auto',
      display: 'block',
    },
  }
}
